
<div class="c-detail" *ngIf="!isLoading; else loader">
    <div class="c-detail__container">
        <mat-card class="c-detail__card" *ngFor="let documento of currentDiploma?.resultadosDaPaginaAtual; let i = index">
            <h1 class="c-detail__name">{{ documento?.modelo }}</h1>
            <ng-container *ngIf="!isIframe">
                <h1 class="c-detail__name">{{ documento?.aluno?.nome }}</h1>
                <h2 class="c-detail__RA">RA: {{ documento?.aluno?.id }}</h2>
            </ng-container>
            <h2 class="c-detail__course">{{ documento?.curso?.nome }}</h2>
            
            <ng-container *ngIf="isDocumentLoading.length > 0 && isDocumentLoading[i].isLoading">
                <mat-progress-bar mode="buffer"></mat-progress-bar>
            </ng-container>
            <div class="c-detail__group-btn">
                <ng-container *ngIf="!isDiplomaInativo">
                    <ng-container *ngFor="let tipo of documento.tipos">
                        <mat-card class="c-card" *ngIf="tipo === 'PDF' || tipo === 'RVDD'">
                            <a href="#" class="c-card__link" (click)="onGetDownload($event, documento.codigo, i, tipo, documento.modelo, '')">
                                <mat-card-subtitle class="c-card__link--subtitle">{{tipo === 'RVDD' ? 'PDF' : tipo}}</mat-card-subtitle>
                                <mat-card-title class="c-card__link--title">
                                    <span class="c-icon">
                                        <mat-icon class="c-icon__icon">remove_red_eye</mat-icon>
                                    </span><br>
                                    <p>VISUALIZAR</p>
                                    <!-- <span>({{tipo}})</span> -->
                                </mat-card-title>
                            </a>
                        </mat-card>
                        <mat-card class="c-card">
                            <a href="#" class="c-card__link" (click)="onGetDownload($event, documento.codigo, i, tipo, documento.modelo, 'download')">
                                <mat-card-subtitle class="c-card__link--subtitle">{{tipo === 'RVDD' ? 'PDF' : tipo}}</mat-card-subtitle>
                                <mat-card-title class="c-card__link--title">
                                    <span class="c-icon">
                                        <mat-icon class="c-icon__icon">cloud_download</mat-icon>
                                    </span><br>
                                    <p>BAIXAR</p>
                                    <!-- <span>({{tipo}})</span> -->
                                </mat-card-title>
                            </a>
                        </mat-card>
                    </ng-container>
                </ng-container>
                <h2 class="warning-text" *ngIf="isDiplomaInativo">
                    O registro informado encontra-se inativo, caracterizando o status do diploma correspondente como anulado, conforme o disposto no art. 8.º, § 4.º, inciso III, da Portaria MEC nº 554/2019.
                </h2>
            </div>
        </mat-card>
    </div>
    <div class="c-detail__info">
        <div class="c-footer" *ngIf="isSair">
            <button mat-flat-button class="c-footer__btn" (click)="onExit()" color="primary">SAIR</button>
        </div>
    </div>
</div>
<ng-template #loader>
    <div class="c-loader">            
        <mat-spinner></mat-spinner>
    </div>
</ng-template>